import React, { useState } from "react";
import { Link, useMatch } from "react-router-dom";
import Banner from "../BannerHubSpot/Banner";
import { Icon, ItemList, Button, Select } from "..";
import "./Header.scss";
import { useIntl } from "react-intl";
import useAppContext from "../../context/Context";
import * as ReactDOM from "react-dom";
import Modal from "../Modal/Modal";

import logoDD from "../../assets/icons/SuscriptionPayments.svg";
import logoBT from "../../assets/images/business-transfer/BusinessTransferLogo.svg";

export const Header = ({ fixed }) => {
  const [open, setOpen] = useState(false);
  const intl = useIntl();
  const match = useMatch("developers");
  const people = useMatch("people-office");
  const cookies = useMatch("cookies");
  const terms = useMatch("terms-conditions");
  const policy = useMatch("privacy-policy");
  const ddMatch = useMatch("direct-debit");
  const pathnames = [
    "",
    "prices",
    "developers",
    "quick-transfer",
    "payment-links",
    "conciliation",
    "returns",
    "terms-conditions",
    "privacy-policy",
    "cookies",
    "people-office",
    "press-brand",
    "uses-cases",
    "eatm",
    "faqs",
    "direct-debit",
    "business-transfer",
  ];
  const currentPathname = window.location.pathname.split("/")[1].toString();

  const { activeCountry } = useAppContext();

  const [openModal, setOpenModal] = useState(false);

  const changeModal = () => {
    setOpenModal(!openModal);
  };

  document.addEventListener("click", function (event) {
    if (
      event.target.className === "itemList null" ||
      event.target.className === "itemList itemList-developers" ||
      event.target.className === "menuToggle open" ||
      event.target.className === "menuToggle" ||
      event.target.tagName === "svg" ||
      event.target.tagName === "path" ||
      event.target.className === ""
    ) {
      return;
    } else {
      setOpen(false);
    }
  });
  console.log("menu");
  return (
    <>
      {openModal === true &&
        ReactDOM.createPortal(
          <Modal
            changeModal={changeModal}
            content={
              <iframe
                title="hsForm_target"
                className="iframe"
                src={
                  activeCountry === "mx"
                    ? "https://share.hsforms.com/14Hl-W1oeQx-uUbcs4v0x5A5l986"
                    : "https://share.hsforms.com/1nESwD7ncTxK4ewZnR1u7yQ5l986"
                }
                frameborder="0"
              ></iframe>
            }
          ></Modal>,
          document.getElementById("portal")
        )}

      <header
        className={`header-page ${match && "developer-page"} ${
          ddMatch && "direct-debit-page"
        } ${fixed ? "menu-fixed" : ""}`}
      >
        {pathnames.includes(currentPathname) && <Banner />}
        {!pathnames.includes(currentPathname) && (
          <img
            src="./notFound/mesh-grad.svg"
            className="mesh-grad"
            alt="mesh-grad"
          />
        )}

        <div className="header-page-container">
          <div className={`mobile-title ${match && "developer-page"}`}>
            <div className="logo">
              <Link to="/" className="logo" onClick={() => setOpen(false)}>
                <Icon name="UFO" size="25px" className="etpayLogo" />
                <Icon name="Lettering" />
              </Link>
              {pathnames.includes(currentPathname) && (
                <div
                  className={`menuToggle ${open ? "open" : ""}`}
                  onClick={() => setOpen(true)}
                ></div>
              )}
            </div>
          </div>
          {pathnames.includes(currentPathname) && (
            <>
              <div
                className={`mobileMenu ${open ? "open" : ""} ${
                  match && "developer-page"
                }`}
              >
                <div className="mobile-title">
                  <div className="logo">
                    <Link
                      to="/"
                      className="logo"
                      onClick={() => setOpen(false)}
                    >
                      <Icon name="UFO" size="25px" className="etpayLogo" />
                      <Icon name="Lettering" />
                    </Link>
                    <div
                      className={`menuToggle ${open ? "open" : ""}`}
                      onClick={() => setOpen(!open)}
                    ></div>
                  </div>
                </div>
                {!people && !cookies && !policy && !terms ? (
                  <>
                    <div className="products-services">
                      <section className="products">
                        <span>
                          {intl.formatMessage({ id: "header.products.title" })}
                        </span>
                        <div className="productMenuContainer">
                          <Link
                            to="quick-transfer"
                            onClick={() => setOpen(false)}
                          >
                            <ItemList>
                              <img
                                className="icon-header"
                                src="/icons/QuickTransfer.png"
                                alt="Quick transfer Icon"
                              />
                              <span>
                                {intl.formatMessage({
                                  id: "header.products.menu.quickTransfer.title",
                                })}
                              </span>
                            </ItemList>
                          </Link>

                          <Link
                            to="payment-links"
                            onClick={() => setOpen(false)}
                          >
                            <ItemList>
                              <img
                                className="icon-header"
                                src="/icons/PaymentLinks.png"
                                alt="Payment Links Icon"
                              />
                              <span>
                                {intl.formatMessage({
                                  id: "header.products.menu.paymentLinks.title",
                                })}
                              </span>
                            </ItemList>
                          </Link>
                          {activeCountry === "cl" && (
                            <>
                              <Link
                                to="direct-debit"
                                onClick={() => setOpen(false)}
                              >
                                <ItemList>
                                  <img
                                    className="icon-header"
                                    src={logoDD}
                                    alt="Debito directo icon"
                                  />
                                  <span>
                                    {intl.formatMessage({
                                      id: "header.products.menu.directdebit.title",
                                    })}
                                  </span>
                                </ItemList>
                              </Link>
                              <Link
                                to="business-transfer"
                                onClick={() => setOpen(false)}
                              >
                                <ItemList>
                                  <img
                                    className="icon-header"
                                    src={logoBT}
                                    alt="Business Transfer icon"
                                  />
                                  <span>
                                    {intl.formatMessage({
                                      id: "header.products.menu.businessTransfer.title",
                                    })}
                                  </span>
                                </ItemList>
                              </Link>
                            </>
                          )}
                          {activeCountry === "mx" && (
                            <Link to="eatm" onClick={() => setOpen(false)}>
                              <ItemList>
                                <img
                                  className="icon-header"
                                  src="/icons/eatm.png"
                                  alt=""
                                />
                                <div>
                                  <span className="title-list">
                                    {intl.formatMessage({
                                      id: "header.products.menu.atm.title",
                                    })}
                                  </span>
                                </div>
                              </ItemList>
                            </Link>
                          )}
                        </div>
                      </section>
                      {/* Services */}
                      <section className="services">
                        <span>
                          {intl.formatMessage({
                            id: "header.services.title",
                          })}
                        </span>
                        <div className="servicesContainer">
                          <Link
                            to="conciliation"
                            onClick={() => setOpen(false)}
                          >
                            <ItemList>
                              <img
                                className="icon-header"
                                src="/icons/Conciliation.png"
                                alt="Conciliation Icon"
                              />
                              <span>
                                {intl.formatMessage({
                                  id: "header.products.menu.conciliation.title",
                                })}
                              </span>
                            </ItemList>
                          </Link>
                          {activeCountry === "mx" ? (
                            ""
                          ) : (
                            <Link to="returns" onClick={() => setOpen(false)}>
                              <ItemList>
                                <img
                                  className="icon-header"
                                  src="/icons/Returns.png"
                                  alt="Devoluciones icon"
                                />
                                <span>
                                  {intl.formatMessage({
                                    id: "header.products.menu.returns.title",
                                  })}
                                </span>
                              </ItemList>
                            </Link>
                          )}
                        </div>
                      </section>
                      <section className="resources">
                        <span>
                          {intl.formatMessage({
                            id: "header.resource.title",
                          })}
                        </span>

                        <div className="resourcesContainer">
                          <a
                            href={intl.formatMessage({
                              id: "header.help.url",
                            })}
                            onClick={() => setOpen(false)}
                          >
                            {intl.formatMessage({
                              id: "header.help.title",
                            })}
                          </a>

                          <Link to="developers" onClick={() => setOpen(false)}>
                            {intl.formatMessage({
                              id: "header.developers.title",
                            })}
                          </Link>

                          <Link to="prices" onClick={() => setOpen(false)}>
                            {intl.formatMessage({
                              id: "header.price.title",
                            })}
                          </Link>
                        </div>
                      </section>
                    </div>

                    <div className="signIn">
                      <div className="btn-container">
                        <a href="https://dashboard.etpay.com/login">
                          <Button bgHoverColor="#fff">
                            <span>
                              {intl.formatMessage({
                                id: "header.signIn.title",
                              })}
                            </span>
                          </Button>
                        </a>
                        <a href="https://dashboard.etpay.com/sign-up">
                          <Button bgHoverColor="#140f33">
                            <span>
                              {intl.formatMessage({
                                id: "button.testFree.text",
                              })}
                            </span>
                          </Button>
                        </a>
                      </div>
                    </div>
                  </>
                ) : cookies || policy || terms ? (
                  <Select />
                ) : (
                  <div className="signIn">
                    <a href={intl.formatMessage({ id: "join.us" })}>
                      <div className="btn-container">
                        {/* <Button bgHoverColor="#140f33" bgColor="#EFEFEF">
                      <span>
                        {intl.formatMessage({
                          id: "people.header.button",
                        })}
                      </span>
                    </Button> */}
                      </div>
                    </a>
                  </div>
                )}
              </div>
            </>
          )}
          <div className="desktopMenu">
            <Link to="/" className="logo" onClick={() => setOpen(false)}>
              <Icon name="UFO" size="25px" className="etpayLogo" />
              <Icon name="Lettering" />
            </Link>
            {pathnames.includes(currentPathname) && (
              <>
                {!people && !cookies && !policy && !terms ? (
                  <>
                    <nav>
                      <div className="">
                        <ItemList
                          className={`itemList ${
                            match && "itemList-developers"
                          }`}
                          onHandleClick={() => {
                            setOpen(!open);
                          }}
                        >
                          <span>
                            {" "}
                            {intl.formatMessage({
                              id: "header.products.title",
                            })}
                          </span>
                          <Icon
                            onHandleClick={(e) => {
                              setOpen(!open);
                            }}
                            name="Vector"
                            className={`${open && "open"}`}
                          />
                        </ItemList>
                        <div
                          className={`submenu ${open && "open"} ${
                            match && "submenu-developers"
                          }`}
                        >
                          <div className="submenu-container">
                            <div className="productsContainer">
                              <span className="title">
                                {intl.formatMessage({
                                  id: "header.products.title",
                                })}
                              </span>
                              <div className="products">
                                <Link
                                  to="quick-transfer"
                                  onClick={() => setOpen(false)}
                                >
                                  <ItemList>
                                    <img
                                      className="icon-header"
                                      src="/icons/QuickTransfer.png"
                                      alt="Quick transfer Icon"
                                    />
                                    <div>
                                      <span className="title-list">
                                        {intl.formatMessage({
                                          id: "header.products.menu.quickTransfer.title",
                                        })}
                                      </span>
                                      <p className="subtitle">
                                        {intl.formatMessage({
                                          id: "header.products.menu.quickTransfer.subtitle",
                                        })}
                                      </p>
                                    </div>
                                  </ItemList>
                                </Link>

                                <Link
                                  to="payment-links"
                                  onClick={() => setOpen(false)}
                                >
                                  <ItemList>
                                    <img
                                      className="icon-header"
                                      src="/icons/PaymentLinks.png"
                                      alt="Payment Links Icon"
                                    />
                                    <div>
                                      <span className="title-list">
                                        {intl.formatMessage({
                                          id: "header.products.menu.paymentLinks.title",
                                        })}
                                      </span>
                                      <p className="subtitle">
                                        {intl.formatMessage({
                                          id: "header.products.menu.paymentLinks.subtitle",
                                        })}
                                      </p>
                                    </div>
                                  </ItemList>
                                </Link>

                                {activeCountry === "cl" && (
                                  <>
                                    <Link
                                      to="direct-debit"
                                      onClick={() => setOpen(false)}
                                    >
                                      <ItemList>
                                        <img
                                          className="icon-header"
                                          src={logoDD}
                                          alt=""
                                        />
                                        <div>
                                          <span className="title-list">
                                            {intl.formatMessage({
                                              id: "header.products.menu.directdebit.title",
                                            })}
                                          </span>
                                          <p className="subtitle">
                                            {intl.formatMessage({
                                              id: "header.products.menu.directdebit.subtitle",
                                            })}
                                          </p>
                                        </div>
                                      </ItemList>
                                    </Link>
                                    <Link
                                      to="business-transfer"
                                      onClick={() => setOpen(false)}
                                    >
                                      <ItemList>
                                        <img
                                          className="icon-header"
                                          src={logoBT}
                                          alt=""
                                        />
                                        <div>
                                          <span className="title-list">
                                            {intl.formatMessage({
                                              id: "header.products.menu.businessTransfer.title",
                                            })}
                                          </span>
                                          <p className="subtitle">
                                            {intl.formatMessage({
                                              id: "header.products.menu.businessTransfer.subtitle",
                                            })}
                                          </p>
                                        </div>
                                      </ItemList>
                                    </Link>
                                  </>
                                )}
                                {activeCountry === "mx" && (
                                  <Link
                                    to="eatm"
                                    onClick={() => setOpen(false)}
                                  >
                                    <ItemList>
                                      <img
                                        className="icon-header"
                                        src="/icons/eatm.png"
                                        alt=""
                                      />

                                      <div>
                                        <span className="title-list">
                                          {intl.formatMessage({
                                            id: "header.products.menu.atm.title",
                                          })}
                                        </span>
                                        <p className="subtitle">
                                          {intl.formatMessage({
                                            id: "header.products.menu.atm.subtitle",
                                          })}
                                        </p>
                                      </div>
                                    </ItemList>
                                  </Link>
                                )}
                              </div>
                            </div>
                            <div className="servicesContainer">
                              <span className="title">Servicios</span>
                              <div className="services">
                                <Link
                                  to="conciliation"
                                  onClick={() => setOpen(false)}
                                >
                                  <ItemList>
                                    <img
                                      className={`icon-header ${
                                        match && "icon-border-developer"
                                      }`}
                                      src="/icons/Conciliation.png"
                                      alt="Conciliation Icon"
                                    />
                                    <div>
                                      <div className="d-flex">
                                        <span className="title-list">
                                          {intl.formatMessage({
                                            id: "header.products.menu.conciliation.title",
                                          })}
                                        </span>
                                      </div>
                                      <p className="subtitle">
                                        {intl.formatMessage({
                                          id: "header.products.menu.conciliation.subtitle",
                                        })}
                                      </p>
                                    </div>
                                  </ItemList>
                                </Link>
                                {activeCountry === "mx" ? (
                                  ""
                                ) : (
                                  <Link
                                    to="returns"
                                    onClick={() => setOpen(false)}
                                  >
                                    <ItemList>
                                      <img
                                        className="icon-header"
                                        src="/icons/Returns.png"
                                        alt="Devoluciones icon"
                                      />
                                      <div>
                                        <div className="d-flex">
                                          <span className="title-list">
                                            {intl.formatMessage({
                                              id: "header.products.menu.returns.title",
                                            })}
                                          </span>
                                        </div>
                                        <p className="subtitle">
                                          {intl.formatMessage({
                                            id: "header.products.menu.returns.subtitle",
                                          })}
                                        </p>
                                      </div>
                                    </ItemList>
                                  </Link>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <a
                        href={intl.formatMessage({
                          id: "header.help.url",
                        })}
                      >
                        <Button
                          bgColor="transparent"
                          bgHoverColor={match && "#646174 !important"}
                        >
                          <span>
                            {intl.formatMessage({
                              id: "header.help.title",
                            })}
                          </span>
                        </Button>
                      </a>
                      <Link to="developers" onClick={() => setOpen(false)}>
                        <Button
                          bgColor="transparent"
                          bgHoverColor={match && "#646174 !important"}
                        >
                          <span>
                            {intl.formatMessage({
                              id: "header.developers.title",
                            })}
                          </span>
                        </Button>
                      </Link>
                      <Link to="prices" onClick={() => setOpen(false)}>
                        <Button
                          bgColor="transparent"
                          bgHoverColor={match && "#646174 !important"}
                        >
                          <span>
                            {intl.formatMessage({
                              id: "header.price.title",
                            })}
                          </span>
                        </Button>
                      </Link>
                    </nav>
                    <div className="signIn">
                      <a href="https://dashboard.etpay.com/login">
                        <Button bgHoverColor="#140f33" bgColor="transparent">
                          <span>
                            {intl.formatMessage({
                              id: "header.signIn.title",
                            })}
                          </span>
                        </Button>
                      </a>
                      <a href="https://dashboard.etpay.com/sign-up">
                        <Button bgHoverColor="#140f33">
                          <span>
                            {intl.formatMessage({
                              id: "button.testFree.text",
                            })}
                          </span>
                        </Button>
                      </a>
                    </div>
                  </>
                ) : cookies || policy || terms ? (
                  <Select />
                ) : (
                  <a href={intl.formatMessage({ id: "join.us" })}>
                    <div className="signIn">
                      <Button
                        bgHoverColor="#140f33"
                        colorHover="#fff"
                        bgColor="#F2F2F2"
                      >
                        {intl.formatMessage({
                          id: "people.header.button",
                        })}
                      </Button>
                    </div>
                  </a>
                )}
              </>
            )}
          </div>
        </div>
      </header>
    </>
  );
};
